<template>
    <div>
        <template v-if="tripCode && tripCode != -1">
            <view_trip></view_trip>
        </template>
        <template v-else>
            <editable_trip></editable_trip>
        </template>

    </div>
</template>

<script>

    import { mapActions} from "vuex";
    import view_trip from "./view_trip";
    import editable_trip from "./editable_trip";


    export default {
        name: "trip",
        components: {editable_trip, view_trip},
        computed: {
            tripCode() {
                return this.$route.params.code;
            }
        },
        methods: {
            ...mapActions( [
                "resetTrip",
                "initializeGoogleApi",
                "retriveTrip",
            ]),
        }
        ,
        mounted() {

            if(this.tripCode && this.tripCode != -1) {
                this.retriveTrip(this.tripCode);
            }else {
                this.initializeGoogleApi();
                this.resetTrip();
            }
        }
    }
</script>

<style scoped>

</style>
